import React from "react";
import { Route, Routes } from "react-router-dom";
import ModelsPage from "../screens/ModelsPage/ModelsPage";
import ModelScreen2 from "../screens/ModelScreen/ModelScreen2";

const ModelsRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<ModelsPage />} />
      <Route path="model" element={<ModelScreen2 />} />
    </Routes>
  );
};

export default React.memo(ModelsRoute);
